<template>
  <section class="content">
    <BlockUI v-show="loadingShow">
      <div class="spinner-border text-info"></div>
      <p>شکیبا باشید...</p>
    </BlockUI>
    <div class="body_scroll">
      <div class="block-header">
        <div class="row">
          <div class="col-lg-7 col-md-6 col-sm-12">
            <h2>مدیریت یادداشت ها</h2>
            <ul class="breadcrumb mt-3">
              <li class="breadcrumb-item">
                <a href="Dashboard">
                  <i class="zmdi zmdi-home"></i>
                  <span>
                    پنل مدیریت
                  </span>
                </a>
              </li>

              <li class="breadcrumb-item active" style="padding-top: 2px;">
                <a href="#" @click="getInvoiceNotes">یادداشت ها</a>
              </li>
            </ul>
            <!--            <button class="btn btn-primary btn-icon mobile_menu" type="button">
                          <i class="zmdi zmdi-sort-amount-desc"></i>
                        </button>-->
          </div>
          <div class="col-lg-5 col-md-6 col-sm-12 text-left">
            <button class="btn btn-primary float-right" type="button" @click="$store.state.menuShow=true">
              <i class="zmdi zmdi-menu align-middle"></i>
            </button>
          </div>
        </div>
      </div>

      <div class="container-fluid">
        <div class="row clearfix">
          <div class="col-lg-12">
            <div class="card">
              <div class="card mt-2">
                <!--                <div class="card-header bg-info">
                                  <div class="row">
                                    <div class="col">
                                      .:: فیلتر گذاری ::.
                                    </div>
                                    <div class="col text-left">
                                      <a href="#" class="text-dark" @click="closeFilterPanel" style="text-align: left">
                                        <small ref="a_CloseFilterPanel">
                                          نمایش
                                        </small>
                                      </a>
                                    </div>
                                  </div>
                                </div>-->
                <div class="card-body bg-white">

                  <form @submit.prevent="getNotesByFilter">
                    <div class="row m-0 mb-2">
                      <!--                      <div class="col border p-0 pt-1 pb-2 m-2">
                                              <div class="col-md-12">
                                                <label class="form-label text-black">تامین کننده</label>
                                                <select
                                                    class="form-control show-tick ms select2"
                                                    data-placeholder="انتخاب کنید"
                                                    style="height:auto;" v-model="filterOrder.SupplierId">

                                                  <option value="678b97bab3f8164454040d18">
                                                    تولیدی صنعتی بهران موتور گلپایگان
                                                  </option>
                                                </select>
                                              </div>
                                            </div>-->

                    </div>
                    <div class="row m-0 mb-2">
                      <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 mb-2">
                        <div class="col-md-12 border p-2">
                          <label class="form-label text-black">شماره فاکتور</label>
                          <input type="number" class="form-control text-left" v-model="filterNotes.InvoiceNumber">
                        </div>
                      </div>
                      <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 mb-2">
                        <div class="col-md-12 border p-2">
                          <label class="form-label text-black">شماره همراه</label>
                          <input type="text" class="form-control text-left" v-model="filterNotes.MobileNumber">
                        </div>
                      </div>
                      <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                        <div class="col-md-12 border p-2">
                          <label class="form-label text-black">نام مشتری</label>
                          <input type="text" class="form-control" v-model="filterNotes.CustomerName">
                        </div>
                      </div>
                      <!--<div class="col border p-0 pt-1 pb-2 m-2">
                                              <div class="col-md-12">
                                                <label class="form-label text-black">تاریخ تحویل</label>
                                                <div class="row">
                                                  <div class="col">
                                                    <date-picker
                                                        type="date"
                                                        :autoSubmit="true"
                                                        format="YYYY-MM-DD"
                                                        display-format="jYYYY/jMM/jDD"
                                                        v-model="filterOrder.FromDate" placeholder="از تاریخ"
                                                        inputClass="form-control text-left"
                                                    ></date-picker>
                                                  </div>
                                                  <div class="col">
                                                    <date-picker
                                                        type="date"
                                                        :autoSubmit="true"
                                                        format="YYYY-MM-DD"
                                                        display-format="jYYYY/jMM/jDD"
                                                        v-model="filterOrder.ToDate" placeholder="تا تاریخ"
                                                        inputClass="form-control text-left"
                                                    ></date-picker>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>-->
                      <!--                      <div class="col border p-0 pt-1 pb-2 m-2">
                                              <div class="col-md-12">
                                                <label class="form-label text-black">تاریخ</label>
                                                <date-picker
                                                    type="date"
                                                    :autoSubmit="true"
                                                    format="YYYY-MM-DD"
                                                    display-format="jYYYY/jMM/jDD"

                                                    inputClass="form-control text-left"
                                                ></date-picker>
                                              </div>
                                            </div>-->
                    </div>


                    <div class="row m-0 mb-2">
                      <div class="col text-right" style="direction: rtl;">
                        <button class="btn btn-primary" type="submit">
                          فیلتر کن
                        </button>
                        <input type="button" class="btn btn-danger" value="پاک کردن فیلتر"
                               @click="getOrderWithoutFilter">
                      </div>
                    </div>
                  </form>
                </div>
              </div>
              <div class="body">
                <simplebar class="col-xl-12" data-simplebar-auto-hide="false" style="height:700px;">
                  <div class="mb-3 p-2" style="background-color:#e3e8e8;border:1px dashed #a2a29f;"
                       v-for="(item,index) in notes" :key="index">
                    <p>
                      <strong>
                        وضعیت:
                      </strong>
                      <a class="text-danger" style="cursor: pointer;" v-if="item.IsRead===false"
                         @click="updateNoteStatus(item.Id,item.IsRead)">
                        رسیدگی نشده
                      </a>
                      <a class="text-success" style="cursor: pointer;" v-if="item.IsRead===true"
                         @click="updateNoteStatus(item.Id,item.IsRead)">
                        رسیدگی شده
                      </a>
                    </p>
                    <p>
                      <strong>
                        شماره فاکتور:
                      </strong>
                      <a style="cursor: pointer;" class="text-primary" @click="openHandlingOrderModal(item.InvoiceId)">{{
                          item.Number
                        }}</a>

                    </p>
                    <p>
                      <strong>
                        مشتری:
                      </strong>
                      <a style="cursor: pointer;" class="text-primary"
                         @click="openCustomerInfoModal(item.CustomerPartyRef)">
                        {{ item.CustomerName }}
                      </a>

                    </p>
                    <p>
                      <strong>
                        قلم فاکتور:
                      </strong>
                      {{ item.Title }}
                    </p>
                    <p>
                      <strong>
                        یادداشت:
                      </strong>
                      {{ item.Note }}
                    </p>
                    <p>
                      <strong>
                        تاریخ ایجاد:
                      </strong>
                      {{ $formatDateTime(item.CreationDate) | moment("HH:mm-jYYYY/jM/jDD") }}
                    </p>
                    <p>
                      <strong>
                        از طرف:
                      </strong>
                      {{ item.Sender }}
                    </p>

                  </div>
                </simplebar>

              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 text-center">
            <!--            <ul
                            class="pagination pagination-warning d-flex flex-row justify-content-center align-items-center">
                          <li
                              class="page-item"
                              v-for="item in pageList"
                              :key="item"
                              :class="{ 'active': pageIndex === item }">
                            <a class="page-link" href="#" @click="getInstallments(item,pageSize)">{{ item }}</a>
                          </li>
                        </ul>-->
            <paginate
                :page-count="pageList"
                :click-handler="getInvoiceNotes"
                :prev-text="'prev'"
                :next-text="'next'" :page-range="5"
                :container-class="'custom-pagination'">
            </paginate>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="div_HandlingModal" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header justify-content-between pt-3">
            <span class="title">اقلام فاکتور</span>
            <span data-dismiss="modal" class="btn btn-link text-muted pt-0">بستن</span>
          </div>
          <div class="modal-body p-0">
            <simplebar class="col-xl-12" data-simplebar-auto-hide="false" style="height:400px;">
              <div>
                <form>
                  <div class="row m-0">
                    <div class="col-md-12 p-0">
                      <div class="table-responsive">
                        <table
                            class="table table-bordered table-striped table-hover">
                          <thead>
                          <tr>
                            <th class="text-center">ردیف</th>
                            <th class="text-center">عنوان</th>
                            <th class="text-center">تعداد</th>
                            <th class="text-center">حمل رایگان</th>
                            <th class="text-center">نصب رایگان</th>
                            <th class="text-center">شعبه</th>
                            <!--<th class="text-center">توضیحات</th>-->
                            <th class="text-center">کارتابل</th>
                            <th class="text-center">وضعیت فعلی</th>
                          </tr>
                          </thead>

                          <tbody class="text-center">
                          <tr v-for="(item,index) in pendingOrderData.PendingOrderList" :key="index"
                              :style="item.IsOwner === 0 ? { backgroundColor: '#f8d7da' } : {}">
                            <td class="p-1 align-middle">{{ index + 1 }}</td>
                            <td class="p-1 align-middle">{{ item.Title }}</td>
                            <td class="p-1 align-middle">{{ item.Quantity }}</td>
                            <td class="p-1 align-middle">
                              <select class="form-control w-auto" aria-label="Default select example" required
                                      v-model="item.IsFreeShipping" :disabled="!item.IsOwner">
                                <option value="false">ندارد</option>
                                <option value="true">دارد</option>

                              </select>
                            </td>
                            <td class="p-1 align-middle">
                              <select class="form-control w-auto" aria-label="Default select example" required
                                      v-model="item.IsFreeInstallation" :disabled="!item.IsOwner">
                                <option value="false">ندارد</option>
                                <option value="true">دارد</option>
                              </select>
                            </td>
                            <td class="p-1 align-middle">{{ item.Branch }}</td>
                            <!--                            <td class="p-1 align-middle">
                                                          <a style="cursor: pointer;" @click="openNewNoteModal(item.InvoiceItemId)">
                                                            <i class="zmdi zmdi-plus" style="color: #5698f5;font-size: 25px;"></i>
                                                          </a>
                                                          &nbsp;
                                                          <a style="cursor: pointer;" @click="openInvoiceNotesListModal(item.InvoiceItemId)">
                                                            <i class="zmdi zmdi-menu" style="color: #5698f5;font-size: 25px;"></i>
                                                          </a>
                                                        </td>-->

                            <td class="p-1 align-middle">
                              <select class="form-control w-auto" aria-label="Default select example"
                                      v-model="item.CurrentOwner"
                                      @change="onPermissionChange(item.Permission,item.CurrentOwner)"
                                      :disabled="!item.IsOwner">
                                <option :value="per.RoleId" v-for="(per,index) in uniquePermissions(item.Permission)"
                                        :key="index">
                                  {{ per.RoleTitle }}
                                </option>
                              </select>
                            </td>
                            <td class="p-1 align-middle">
                              <select class="form-control w-auto" aria-label="Default select example"
                                      v-model="item.Status" :disabled="!item.IsOwner">
                                <option :value="per.PermissionId"
                                        v-for="(per,index) in onPermissionChange(item.Permission,item.CurrentOwner)"
                                        :key="index">
                                  {{ per.Title }}
                                </option>
                              </select>
                            </td>

                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </simplebar>

          </div>
          <div class="modal-footer">
            <div class="row">
              <div class="col text-right" style="direction: rtl;">
                <button class="btn btn-primary" @click="handlingOrder">
                  ثبت تغییرات
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="modal fade" id="div_AlertModal" tabindex="-1" role="dialog" style="z-index: 10000 !important;">
      <div class="modal-dialog modal-dialog-centered modal-md" role="document">
        <div class="modal-content">
          <div class="modal-header bg-info justify-content-between pt-1 pb-1">
            <span class="title text-white">پیغام سیستم</span>
            <span data-dismiss="modal" class="btn btn-link text-white pt-1">بستن</span>
          </div>
          <div class="modal-body">
            <simplebar class="col-xl-12" data-simplebar-auto-hide="false" style="height:400px;">
              <div ref="div_AlertModalMessage"></div>
            </simplebar>
          </div>
        </div>
      </div>
    </div>


    <div class="modal fade" id="div_CustomerInfoModal" tabindex="-1" role="dialog" style="z-index: 10000 !important;">
      <div class="modal-dialog modal-dialog-centered modal-md" role="document">
        <div class="modal-content">
          <div class="modal-header bg-info justify-content-between pt-1 pb-1">
            <span class="title text-white">پیغام سیستم</span>
            <span data-dismiss="modal" class="btn btn-link text-white pt-1">بستن</span>
          </div>
          <div class="modal-body">
            <simplebar class="col-xl-12" data-simplebar-auto-hide="false" style="height:400px;">
              <div ref="div_CustomerInfo"></div>
            </simplebar>
          </div>
        </div>
      </div>
    </div>


  </section>
</template>
<script>
/* eslint-disable */
import axios from "axios";
import simplebar from "simplebar-vue";
import "simplebar/dist/simplebar.min.css";
// import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import Paginate from "vuejs-paginate";
// import Vue from 'vue';
import VuePersianDatetimePicker from "vue-persian-datetime-picker";

// import moment from "vue-moment-jalaali";
// import VueUploadMultipleImage from 'vue-upload-multiple-image';
// import ClassicEditor from "@ckeditor/ckeditor5-build-classic";


export default {
  data() {
    return {
      loadingShow: false,
      pageSize: 10,
      notes: [],
      pageList: 0,
      pageIndex: 0,
      filterNote: false,
      filterNotes: {
        InvoiceNumber: "",
        CustomerName: "",
        MobileNumber: ""
      },
      pendingOrderData: {PendingOrderList: [], PendingOrderCount: 0}
    };
  },
  methods: {
    getOrderWithoutFilter() {
      let self = this;
      self.filterNote = false;
      self.filterNotes.InvoiceNumber = "";
      self.filterNotes.CustomerName = "";
      self.filterNotes.MobileNumber = "";
      self.getInvoiceNotes(1, 20)
    },
    getNotesByFilter() {
      let self = this;
      self.filterNote = true;
      self.getInvoiceNotes(1, 20);
    },
    getInvoiceNotes(pageTarget = 1, limit = 20) {
      let self = this;
      self.pageIndex = pageTarget;
      let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
      self.loadingShow = true;
      axios
          .post("https://araksolar.ir/webhook/GetItemNotes", {

            params: {
              Page: pageTarget,
              Limit: limit,
              //Invoice: invoice,
              FilterNote: self.filterNote,
              Filter: self.filterNotes
            }
          }, {
            headers: {
              authorization: userInfo.Token
            }
          })
          .then(function (res) {
            console.log(res.data);
            self.notes = res.data[0].notes;
            let pageCount =
                res.data[0].noteCount % 20 === 0
                    ? res.data[0].noteCount / 20
                    : res.data[0].noteCount / 20 + 1;
            self.pageList = Math.floor(pageCount);
            self.loadingShow = false;
          })
          .catch(function (error) {
            self.loadingShow = false;
          });
    },
    updateNoteStatus(noteId, status) {
      let self = this;
      let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
      self.loadingShow = true;
      axios.post("https://khorshidshab.runflare.run/webhook/UpdateNoteStatus", {
        NoteId: noteId,
        Status: status
      }, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: userInfo.Token
        }
      })
          .then(function (res) {
            let {Data, Message, Status} = res.data;
            console.log(Data);
            self.loadingShow = false;

            if (Status === 1) {
              self.getInvoiceNotes(self.pageIndex);
              self.$toast.open({
                position: "bottom-right",
                message: Message,
                type: "success",
                duration: 5000
              });
            } else {
              self.$toast.open({
                position: "bottom-right",
                message: Message,
                type: "error",
                duration: 5000
              });
            }

          })
          .catch(function (error) {
            console.log(error);
            self.loadingShow = false;
          })
          .finally(function (res) {
            // console.log("TEST");
            self.loadingShow = false;
          });
    },
    openHandlingOrderModal(invoiceId) {
      let self = this;
      console.log(invoiceId);
      let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
      // self.shipmentType = shipmentType;
      self.loadingShow = true;
      axios.get("https://araksolar.ir/webhook/GetOrderItems", {
        headers: {
          'Content-Type': 'application/json',
          Authorization: userInfo.Token
        },
        params: {
          InvoiceId: invoiceId
        }
      })
          .then(function (res) {
            // let {Data, Message, Status} = res.data;
            console.log(res.data);

            self.pendingOrderData.PendingOrderList = res.data.invoiceItems;
            /*self.pendingOrderData.PendingOrderList = self.pendingOrderData.PendingOrderList.map(item => ({
              ...item,
              ShipmentType: shipmentType
            }));*/
            //console.log(self.pendingOrderData.PendingOrderList)
            //self.permissions = res.data.permission;
            //self.subPermissions=res.data.subPermission;
            /*self.filterPermissions = res.data.permission;
            self.permissions = Object.values(
                res.data.permission.reduce((acc, current) => {
                  acc[current.RoleId] = current;
                  return acc;
                }, {})
            );*/

            self.loadingShow = false;
            $("#div_HandlingModal").modal("show");
            /*if (Status === 1) {
              self.loadingShow = false;
              self.customers = Data.Customers;
            } else {
              self.loadingShow = false;
              self.$refs.div_AlertModalMessage.innerHTML = Message;
              $("#div_AlertModal").modal({backdrop: "static"});
            }*/
          })
          .catch(function (error) {
            console.log(error);
            self.loadingShow = false;
          })
          .finally(function (res) {
            self.loadingShow = false;
          });
    },
    handlingOrder() {
      let self = this;
      let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
      self.loadingShow = true;
      axios.post("https://araksolar.ir/webhook/HandlingOrder", {
        ItemList: self.pendingOrderData.PendingOrderList
      }, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: userInfo.Token
        }
      })
          .then(function (res) {
            let {Data, Message, Status} = res.data[0];
            console.log(Data);

            if (Status === 1) {
              self.loadingShow = false;
              //self.getOrders(self.pageIndex);
              self.$toast.open({
                position: "bottom-right",
                message: Message,
                type: "success",
                duration: 5000
              });
              $("#div_HandlingModal").modal("hide");

            } else {
              self.loadingShow = false;
              // self.$refs.div_AlertModalMessage.innerHTML = Message;
              // $("#div_AlertModal").modal({backdrop: "static"});
            }
          })
          .catch(function (error) {
            console.log(error);
            self.loadingShow = false;
          })
          .finally(function (res) {
            // console.log("TEST");
            self.loadingShow = false;
          });
    },
    uniquePermissions(permissions) {
      const unique = [];
      const map = new Map();
      for (const per of permissions) {
        if (!map.has(per.RoleId)) {
          map.set(per.RoleId, true);
          unique.push(per);
        }
      }
      return unique;
    },
    onPermissionChange(permission, permissionId) {
      let self = this;
      console.log(permissionId);
      return permission.filter(sub => sub.RoleId === permissionId);
      // console.log(self.permissions.filter(sub => sub.RoleId === permissionId)) ;
    },
    openCustomerInfoModal(partyRef) {
      let self = this;
      let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
      self.loadingShow = true;
      axios.get("https://araksolar.ir/webhook/GetCustomerInfo", {
        headers: {
          'Content-Type': 'application/json',
          Authorization: userInfo.Token
        },
        params: {
          PartyRef: partyRef
        }
      })
          .then(function (res) {
            // let {Data, Message, Status} = res.data;
            console.log(res.data);
            self.$refs.div_CustomerInfo.innerHTML = `<p><strong>آدرس: </strong>${res.data[0].Address}</p>`;
            self.$refs.div_CustomerInfo.innerHTML += `<p><strong>تلفن: </strong><a href="tel:${res.data[0].Phone}">${res.data[0].Phone}</a></p>`;
            $("#div_CustomerInfoModal").modal({backdrop: "static"});
            self.loadingShow = false;
            //$("#div_CustomerInfo").modal("show");
            /*if (Status === 1) {
              self.loadingShow = false;
              self.customers = Data.Customers;
            } else {
              self.loadingShow = false;
              self.$refs.div_AlertModalMessage.innerHTML = Message;
              $("#div_AlertModal").modal({backdrop: "static"});
            }*/
          })
          .catch(function (error) {
            console.log(error);
            self.loadingShow = false;
          })
          .finally(function (res) {
            self.loadingShow = false;
          });
    },
  },
  created() {
    let self = this;
    self.getInvoiceNotes(1, 20);
  },
  mounted() {

  },
  computed: {},
  watch: {},
  components: {
    simplebar, 'paginate': Paginate, datePicker: VuePersianDatetimePicker,
  }
};
</script>

<style>
.vs__search::placeholder,
.vs__dropdown-toggle,
.vs__dropdown-menu {
  margin-bottom: 5px;
  text-transform: lowercase;
  font-variant: small-caps;
  text-align: right !important;
  direction: rtl !important;
  padding: 2px;
}

.text-right {
  direction: rtl !important;
  text-align: right !important;
}

.reset {
  all: revert;
}

.vpd-icon-btn {
  margin-bottom: 0px !important;
}

.mp-custom-input-text {
  font-size: 25px;
  direction: ltr;
  text-align: left;
}

.table-responsive {
  overflow-x: auto;
}

.table td, .table th {
  white-space: nowrap;
  /*min-height: 50 px;*/
}

th {
  font-weight: initial !important;
}

.highlight {
  background-color: #B2FF59;
}

.bg-white {
  color: initial;
}

.disabled-row {
  background-color: #f0f0f0;
  color: #919090;
  pointer-events: none;
}

</style>
